import { faEuroSign, faQuestion, faAngleUp, faReceipt, faSyncAlt, faEye, faChartBar } from '@fortawesome/free-solid-svg-icons'; 	

export const businessPartnerNavItems = [
{
    key: "revenue",
    title: "revenue",
    to: "/revenue",
    icon: faEuroSign,
    hasSubNav: false,
    subNav: []
},
{
    key: "intakebook",
    title: "monthly_intakebook",
    to: "/intakebook",
    icon: faReceipt,
    hasSubNav: false,
    subNav: []
},
{
    key: "changerequest",
    title: "change_request",
    to: "/changerequest",
    icon: faSyncAlt,
    hasSubNav: false,
    subNav: []
},
{
    key: "help",
    title: "help",
    icon: faQuestion,
    hasSubNav: true,
    secondaryIcon: faAngleUp,
    subNav: [{
        key: "usermanual",
        title: "usermanual",
        to: "/usermanual",
        isOpenInNewTab: false,
        hasSubNav: false,
        subNav: []
    },{
        key: "support",
        title: "support",
        isOpenInNewTab: false,
        to: "/support",
        hasSubNav: false,
        subNav: []
    },
    {
        key: "elearning",
        title: "elearning",
        isOpenInNewTab: false,
        to: "/elearning",
        hasSubNav: false,
        subNav: []
    }]
}
];

export const nmbsUserNavItems = [{
    key: "overview",
    title: "Overview",
    to: "/overview",
    icon: faEuroSign,
    hasSubNav: false,
    isEditAccessOnly: false,
    subNav: []
},
{
    key: "changerequest",
    title: "change_request",
    to: "/changerequest",
    icon: faSyncAlt,
    hasSubNav: false,
    isEditAccessOnly: false,
    subNav: []
},
{
    key: "audit",
    title: "audit",
    to: "/audit",
    icon: faEye,
    hasSubNav: false,
    isEditAccessOnly: true,
    subNav: []
},
{
    key: "reports",
    title: "reports",
    to: "/reports",
    icon: faChartBar,
    hasSubNav: false,
    isEditAccessOnly: false,
    subNav: []
}
]
